import axios from 'axios';

export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';

/** Get the stored auth token from either localStorage or sessionStorage. */
export function getStoredToken(): string | null {
  return localStorage.getItem('token') || sessionStorage.getItem('token');
}

/** Remove the auth token from both storage locations. */
export function clearStoredToken(): void {
  localStorage.removeItem('token');
  sessionStorage.removeItem('token');
  localStorage.removeItem('rememberMe');
}

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const publicPaths = ['/login', '/register'];
      const isPublicPage = publicPaths.includes(window.location.pathname);
      if (!isPublicPage) {
        clearStoredToken();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
